export const defaultDesignerUiConfig = {
  customPropPanels: [],
  propPanelFilter: () => true,
  materialBoxFilter: () => true,
  customMaterialBoxes: [],
  toolBarFilter: () => true,
  domTreeView: true
};